import { gql } from '@apollo/client';
import {
  PROJECT_FEATURED_PHOTO_FRAGMENT,
  ASSET_FEED_ITEM_FRAGMENT,
  ASSET_FEED_ITEM_PHOTO_FRAGMENT,
  ASSET_FEED_ITEM_VIDEO_FRAGMENT,
} from './fragments.graphql';

export const GET_ASSET_FEED = gql`
  query GetAssetFeed(
    $id: ID!
    $first: Int
    $after: String
    $sortDirection: OrderDirection!
    $capturedAfter: ISO8601DateTime
    $capturedBefore: ISO8601DateTime
    $tags: [String!]
    $tagsOperator: TagsOperatorEnum
    $groups: [ID!]
    $users: [ID!]
    $projects: [ID!]
    $types: [AssetTypeEnum]
  ) {
    node(id: $id) {
      id
      __typename
      ... on AssetFeedable {
        assetFeed(
          first: $first
          after: $after
          orderBy: { field: CAPTURE_DATE, direction: $sortDirection }
          capturedAfter: $capturedAfter
          capturedBefore: $capturedBefore
          tags: $tags
          tagsOperator: $tagsOperator
          groups: $groups
          users: $users
          projects: $projects
          types: $types
          includeCollaborations: true
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              __typename
              ... on AssetFeedItem {
                ...AssetFeedItemFragment
              }
              ... on RecordableInterface {
                commentsCount
                voiceNotesCount
                tagsCount
              }
              ... on Photo {
                ...AssetFeedItemPhotoFragment
              }
              ... on Video {
                ...AssetFeedItemVideoFragment
              }
            }
          }
        }
      }
    }
  }

  ${ASSET_FEED_ITEM_FRAGMENT}
  ${ASSET_FEED_ITEM_PHOTO_FRAGMENT}
  ${ASSET_FEED_ITEM_VIDEO_FRAGMENT}
`;

export const ASSET_STATUS_CHANGED_SUBSCRIPTION = gql`
  subscription OnAssetStatusChanged($feedableId: ID!) {
    assetStatusChanged(feedableId: $feedableId) {
      status
      assetItem {
        __typename
        ... on AssetFeedItem {
          ...AssetFeedItemFragment
        }
        ... on RecordableInterface {
          commentsCount
          voiceNotesCount
          tagsCount
        }
        ... on Photo {
          project {
            ...ProjectFeaturedPhotoFragment
          }
          ...AssetFeedItemPhotoFragment
        }
        ... on Video {
          ...AssetFeedItemVideoFragment
        }
      }
    }
  }

  ${ASSET_FEED_ITEM_FRAGMENT}
  ${ASSET_FEED_ITEM_PHOTO_FRAGMENT}
  ${ASSET_FEED_ITEM_VIDEO_FRAGMENT}
  ${PROJECT_FEATURED_PHOTO_FRAGMENT}
`;

export const ASSET_DELETED_SUBSCRIPTION = gql`
  subscription OnAssetDeleted($feedableId: ID!) {
    assetDeleted(feedableId: $feedableId) {
      assetItem {
        __typename
        ... on AssetFeedItem {
          id
        }
      }
    }
  }
`;

export const ASSET_REASSIGNED_SUBSCRIPTION = gql`
  subscription OnAssetReassigned($feedableId: ID!) {
    assetReassigned(feedableId: $feedableId) {
      assetItem {
        __typename
        ... on AssetFeedItem {
          ...AssetFeedItemFragment
        }
        ... on RecordableInterface {
          commentsCount
          voiceNotesCount
          tagsCount
        }
        ... on Photo {
          ...AssetFeedItemPhotoFragment
        }
        ... on Video {
          ...AssetFeedItemVideoFragment
        }
      }
    }
  }

  ${ASSET_FEED_ITEM_FRAGMENT}
  ${ASSET_FEED_ITEM_PHOTO_FRAGMENT}
  ${ASSET_FEED_ITEM_VIDEO_FRAGMENT}
`;

export const ASSET_PROCESSED_SUBSCRIPTION = gql`
  subscription OnAssetProcessed($feedableId: ID!) {
    assetProcessed(feedableId: $feedableId) {
      assetItem {
        __typename
        ... on AssetFeedItem {
          ...AssetFeedItemFragment
        }
        ... on RecordableInterface {
          commentsCount
          voiceNotesCount
          tagsCount
        }
        ... on Photo {
          ...AssetFeedItemPhotoFragment
        }
        ... on Video {
          ...AssetFeedItemVideoFragment
        }
      }
    }
  }

  ${ASSET_FEED_ITEM_FRAGMENT}
  ${ASSET_FEED_ITEM_PHOTO_FRAGMENT}
  ${ASSET_FEED_ITEM_VIDEO_FRAGMENT}
`;
